import { render, staticRenderFns } from "./ChatStartModal.vue?vue&type=template&id=6b91d25e&"
import script from "./ChatStartModal.vue?vue&type=script&lang=js&"
export * from "./ChatStartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports